export interface AttachableFile {
  id: string
  fileName: string
  fileUrl: string
  fileType: string
  fileSize: number
  mimeType: string
  storagePath?: string
}

export interface AlreadyAttached {
  name: string
  size: number
}

export interface AutoAttachResolution {
  toAttach: AttachableFile[]
  missingTypeIds: string[]
}

export function resolveAutoAttachments(
  files: AttachableFile[],
  configuredTypeIds: string[],
  alreadyAttached: AlreadyAttached[]
): AutoAttachResolution {
  const attachedKey = new Set(alreadyAttached.map(a => `${a.name}::${a.size}`))
  const toAttach: AttachableFile[] = []
  const missingTypeIds: string[] = []

  for (const typeId of configuredTypeIds) {
    const ofType = files.filter(f => f.fileType === typeId)
    if (ofType.length === 0) {
      missingTypeIds.push(typeId)
      continue
    }
    for (const f of ofType) {
      if (!attachedKey.has(`${f.fileName}::${f.fileSize}`)) {
        toAttach.push(f)
      }
    }
  }

  return { toAttach, missingTypeIds }
}
